import axios from "axios";

/**
 * Base URL for authentication server without trailing slash
 */
const BASE_SERVER = "https://demo-service.saliorel.cloud";
const FS = {
  /**
   * Context actions
   */
  Context: {
    /**
     * List all contexts that are accessible by the current user
     */
    list: () =>
      axios
        .get(`${BASE_SERVER}/context`, { withCredentials: true })
        .then(res => res.data),

    /**
     * Creates a new context with the specified data
     */
    create: data =>
      axios
        .post(
          `${BASE_SERVER}/context`,
          {
            ...data
          },
          {
            withCredentials: true
          }
        )
        .then(res => res.data),

    /**
     * Updates an existing context with the specified data
     */
    save: (contextIdentifer, updatedContext) =>
      axios
        .put(
          `${BASE_SERVER}/context/${contextIdentifer}`,
          {
            ...updatedContext
          },
          {
            withCredentials: true
          }
        )
        .then(res => res.data)
  },
  /**
   * Document actions
   */
  Document: {
    /**
     * List all documents in a specific context that are visible
     * to the current user
     */
    list: context =>
      axios
        .get(`${BASE_SERVER}/documents`, {
          params: { contextIdentifier: context },
          withCredentials: true
        })
        .then(res => res.data),

    /**
     * Creates a new document with the specified data
     */
    create: (data, contextIdentifier) =>
      axios
        .post(
          `${BASE_SERVER}/documents`,
          {
            ...data,
            contextIdentifier
          },
          {
            withCredentials: true
          }
        )
        .then(res => res.data),

    /**
     * Update a new document with a specified identifier
     */
    save: (documentIdentifier, updatedDocument) =>
      axios
        .post(
          `${BASE_SERVER}/documents/${documentIdentifier}`,
          {
            ...updatedDocument
          },
          {
            withCredentials: true
          }
        )
        .then(res => res.data),

    /**
     * Delete a new document with a specified identifier
     */
    deleteDocument: (documentIdentifier, context) =>
      axios
        .delete(`${BASE_SERVER}/documents/${documentIdentifier}`, {
          params: { contextIdentifier: context },
          withCredentials: true
        })
        .then(res => res.data)
  }
};

export default FS;



// WEBPACK FOOTER //
// ./src/api/FS.js